export default __webpack_public_path__ + "static/media/box4.e89e1e85.png";